import React from 'react';

export default function AdminPublications() {
  const [publication, setPublication] = React.useState({
    id:'',
    publicationName : '',
    projectName : '',
    conferenceName : '',
    publisher: '',
    publicationDate: '',
    DOI : ''
  });



  const handleInputs = (e) => {
    const { name, value } = e.target;
    setPublication((prevPublication) => ({ ...prevPublication, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const {id,publicationName,conferenceName,publisher,publicationDate,DOI } = publication;

    const res = await fetch('/admin/publications', {
      method: 'POST',
      mode : "cors",
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ id,publicationName,conferenceName,publisher,publicationDate,DOI  }),
    });

    const data = await res.json();
    console.log(data);

    if (data.status === 500 || !data) {
      window.alert('Publication entry failed');
      console.log('Publication entry failed');

    } else if (data.status === 200) {
      window.alert('Publication entry successful');
      console.log('Publication entry successful');
    } else if (data.status === 422) {
      window.alert('Publication ID already exists');
      console.log('Publication ID already exists');
    }
    
    
    
  };

  return (
    <div className="admin-publication">
      <form onSubmit={handleSubmit} className="publication-form">
        <input type="number" name="id" placeholder="ID" value={publication.id} onChange={handleInputs} />

        <input type="text" name="publicationName" placeholder="Name" value={publication.publicationName} onChange={handleInputs} />

        <input
          type="text"
          name="conferenceName"
          placeholder="Conferencename"
          value={publication.conferenceName}
          onChange={handleInputs}
        />
        <input
          type="text"
          name="publisher"
          placeholder="publisher"
          value={publication.publisher}
          onChange={handleInputs}
        />

        <input type="text" name="publicationDate" placeholder="Publicationdate" value={publication.publicationDate} onChange={handleInputs} />

        <input
          type="text"
          name="DOI"
          placeholder="DOI"
          value={publication.DOI}
          onChange={handleInputs}
        />


        <button type="submit">Submit</button>
      </form>
    </div>
  );
}
